import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {SharedModule} from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './login/login.component';
import {AuthInterceptor} from './helpers/auth.interceptor';
import {GridModule} from './grid/grid.module';
import { UserSettingsComponent } from './user/user-settings/user-settings.component';
import { AdminPanelComponent } from './admin/admin-panel/admin-panel.component';
import {MatTabsModule} from '@angular/material/tabs';
import { UserManagementActionsComponent } from './admin/cell/user-management-actions/user-management-actions.component';
import { AiReportDialogComponent } from './components/dialog/ai-report-dialog/ai-report-dialog.component';
import { SyncModeDialogComponent } from './components/dialog/sync-mode-dialog/sync-mode-dialog.component';
import {AgGridModule} from 'ag-grid-angular';
import { AiReplaceDialogComponent } from './components/dialog/ai-replace-dialog/ai-replace-dialog.component';
import { GridAiTagsComponent } from './components/grid-ai-tags/grid-ai-tags.component';
import {MatDividerModule} from "@angular/material/divider";
import { ScheduledEventsComponent } from './admin/scheduled-events/scheduled-events.component';
import { ScheduledEventDialogComponent } from './admin/dialogs/scheduled-event-dialog/scheduled-event-dialog.component';
import { BulkPricingModelsComponent } from './admin/bulk-pricing-models/bulk-pricing-models.component';
import { BulkPricingModelDialogComponent } from './admin/dialogs/bulk-pricing-model-dialog/bulk-pricing-model-dialog.component';
import { ImageSyncDialogComponent } from './dialogs/image-sync-dialog/image-sync-dialog.component';
import { WeightEstimatorComponent } from './admin/weight-estimator/weight-estimator.component';
// import { UserManagementComponent } from './admin/user-management/user-management.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    UserSettingsComponent,
    AdminPanelComponent,
    UserManagementActionsComponent,
    AiReportDialogComponent,
    AiReplaceDialogComponent,
    SyncModeDialogComponent,
    GridAiTagsComponent,
    ScheduledEventsComponent,
    ScheduledEventDialogComponent,
    BulkPricingModelsComponent,
    BulkPricingModelDialogComponent,
    ImageSyncDialogComponent,
    WeightEstimatorComponent,
    // UserManagementComponent,
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        SharedModule,
        BrowserAnimationsModule,
        GridModule,
        MatTabsModule,
        AgGridModule,
        MatDividerModule
    ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
